<kendo-dialog *ngIf="dialogOpened" (close)="close()" [width]="900">
    <kendo-dialog-titlebar>
        <h3>{{ 'IMPORT-COMMUNITY-PROGRAMS-FROM-CSV' | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="importForm">
        <kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)">
            <kendo-tabstrip-tab title="{{ 'IMPORT-COMMUNITY-PROGRAMS-SELECTION' | translate }}" [selected]="true">
                <ng-template kendoTabContent>
                    <div class="k-form">
                        <div class="row">
                            <div class="col-12">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'FILENAME' | translate}} *
                                    </span>
                                    <input id="importFilename" kendoTextBox formControlName="importFilename"
                                        [readonly]="true" />
                                    <input type="file" id="csvFile" #csvFileInput accept=".csv, text/plain"
                                        class="d-none" (change)="handleCsvInput($event.target.files)" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="importFilename.hasError('required') && importFilename.touched">
                                        {{'IMPORT-COMMUNITY-PROGRAMS-FILE-REQUIRED' | translate}}
                                    </div>
                                    <button appPreventClick kendoButton type="button" (click)="csvFileInput.click()"
                                        class="mt-3 float-right">
                                        {{'IMPORT-COMMUNITY-PROGRAMS-SELECT-FILE' | translate}}
                                        <i class="far fa-upload fa-white"></i>
                                    </button>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="k-text-uppercase dark mr-2" for="validateOnly">{{
                                    'IMPORT-COMMUNITY-PROGRAMS-VALIDATE-ONLY' | translate }}
                                </label>
                                <kendo-switch formControlName="validateOnly" onLabel="{{'YES' | translate }}"
                                    offLabel="{{'NO' | translate }}">
                                </kendo-switch>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">* {{'REQUIRED-FIELDS' | translate}}</div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'IMPORT-COMMUNITY-PROGRAMS-RESULTS' | translate }}"
                (tabSelect)="onTabSelect($event)">
                <ng-template kendoTabContent>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row" *ngIf="importResults.length > 0" style="margin-top:3px">
                                <div class="col-md-4">
                                    <label class="text-right headerText header-label">{{'SUMMARY' | translate}}:</label>
                                </div>
                                <div class="col-md-4">
                                    <i class="fas fa-check-circle import-valid"
                                        title="{{'IMPORT-COMMUNITY-PROGRAMS-TOTAL-VALID' | translate}}">
                                    </i>&nbsp;{{totalSuccesses}}
                                </div>
                                <div class="col-md-4">
                                    <i class="fas fa-times-circle import-invalid"
                                        title="{{'IMPORT-COMMUNITY-PROGRAMS-TOTAL-INVALID' | translate}}">
                                    </i>&nbsp;{{totalErrors}}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                                <app-advanced-mode id="enableAdvanced" [storageKey]="'provider-import'"
                                    (collapsibleToggle)="enableAdvanced=$event">
                                </app-advanced-mode>
                            </div>
                        </div>
                    </div>
                    <kendo-grid [data]="view.gridData" [height]="350" [loading]="view.loading" [sortable]="true"
                        [navigable]="true" [sort]="view.state.sort" [filterable]="enableAdvanced"
                        [filter]="view.state.filter" [groupable]="enableAdvanced" [group]="view.groups"
                        [selectable]="{ mode: 'single' }" [columnMenu]="enableAdvanced" [resizable]="true"
                        [reorderable]="enableAdvanced" (groupChange)="groupChange($event)"
                        (dataStateChange)="dataStateChange($event)" class="mt-2 mb-2">
                        <kendo-grid-column *ngFor="let col of resultcolumns" [field]="col.field" [width]="col.width"
                            [title]="col.titleKey | translate">
                            <ng-template *ngIf="col.field === 'valid'" kendoGridCellTemplate let-dataItem>
                                <div class="text-center" style="margin:auto;">
                                    <i *ngIf="dataItem !== undefined && dataItem.valid === textYES"
                                        class="fas fa-check-circle import-valid">
                                    </i>
                                    <i *ngIf="dataItem !== undefined && dataItem.valid === textNO"
                                        class="fas fa-times-circle import-invalid">
                                    </i>
                                </div>
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
    </form>
    <kendo-dialog-actions>
        <button class="k-button k-primary"
            [disabled]="!importForm.valid || !importForm.dirty || view.loading || communityProviderProgramsImported || selectedTab === 1"
            (click)="onImport($event)">
            {{(validateOnly.value ? 'IMPORT-COMMUNITY-PROGRAMS-VALIDATE-ONLY' : 'IMPORT') | translate }}
        </button>
        <button class="k-button" (click)="close()" [disabled]="view.loading">{{ 'CLOSE' | translate }}</button>
    </kendo-dialog-actions>
</kendo-dialog>